import { authActions } from "../../store/auth-Slice";
import { getRefreshToken } from "../Api";

const patchRequest = async (uri, data, headers, dispatch) => {
    const response = await fetch(
        uri, {
        method: 'PATCH',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            Authorization: headers.token,
            Client: headers.client,
        },
    });
    if (!response.ok) {
        throw new Error('Fetching failed.');
    }

    const responseData = await response.json();
    console.log(responseData);

    if (responseData && responseData.success) {
        return responseData;
    }
    return responseData.data.success;
};

export default patchRequest
